module.exports = __webpack_public_path__ + "img/what7.4f08c1dc.png";